import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import WordPage from './WordPage';
import Navbar from './Navbar';

function AppWithNavbar() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
      <Navbar />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/word-generator" element={<WordPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppWithNavbar;